"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var image_1 = require("../../../../../../../components/image");
var utils_1 = require("@doshexchnage/utils");
var react_2 = require("react");
var formatDate_1 = require("../../../../../../../helpers/formatDate");
var useClient_1 = require("../../../../../../../hooks/useClient");
function StatusCellView(_a) {
    var cellValue = _a.cellValue;
    var color = (0, react_2.useMemo)(function () {
        if ([
            "ACTIVE",
            "COMPLETED",
            "FUlFILLED",
            "PROCESSED",
            "ORDERED",
            "READY",
            "ARRIVED",
            "DELIVERED",
            "ONLINE",
            "AVAILABLE",
            "COMPLETE",
            "SUCCESS",
            "ACCEPTED",
        ].includes(cellValue)) {
            return "success";
        }
        else if (["INACTIVE", "CANCELLED", "OFFLINE"].includes(cellValue)) {
            return "default";
        }
        else if (["UPDATED", "OPEN", "RETURNED", "PACKED", "VIEWED"].includes(cellValue)) {
            return "default";
        }
        else if (["SUSPENDED", "ABANDONED", "RETURNED-BY-CUSTOMER", "DECLINED", "EXPIRED"].includes(cellValue)) {
            return "danger";
        }
        else if ([
            "AWAITING-SIGNUP",
            "PROCESSING",
            "CHECKED-OUT",
            "POS-ORDERED",
            "COLLECTED",
            "DELIVERY-READY",
            "PARTIALLY-DELIVERED",
            "AWAITING-EMAIL-CONFIRMATION",
            "SENT",
            "PENDING",
        ].includes(cellValue)) {
            return "warning";
        }
    }, [cellValue]);
    return ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap text-xs capitalize", color: color, size: "sm", variant: "soft", children: cellValue }));
}
function useRenderCellViews() {
    var client = (0, useClient_1.useClient)().client;
    var renderCellViews = (0, react_2.useCallback)(function (cellValue) {
        return [
            { key: "image", content: (0, jsx_runtime_1.jsx)(image_1.Image, { src: cellValue, className: "w-10 aspect-square rounded-lg" }) },
            { key: "name", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue }) },
            { key: "createdAt", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: (0, utils_1.formatDateTime)(new Date(cellValue)) }) },
            { key: "end_date", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: (0, utils_1.formatDateTime)(new Date(cellValue)) }) },
            { key: "free_trial", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue ? "True" : "False" }) },
            { key: "payment_type", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue }) },
            {
                key: "last_redemption_date",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: (0, formatDate_1.formatDate)(cellValue) }),
            },
            { key: "status", content: (0, jsx_runtime_1.jsx)(StatusCellView, { cellValue: cellValue }) },
        ];
    }, [client]);
    return (0, react_2.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
